import React, { useRef } from 'react';

import classNames from 'classnames';
import SearchIcon from 'icons/search.svg';
import PropTypes from 'prop-types';

export default function SearchField({
  additionalClasses,
  autoFocus = false,
  isDisabled = false,
  name,
  onChange,
  onReset,
  placeholder,
  value,
  withoutIcon = false,
}) {
  const inputRef = useRef();

  const handleKeyDown = (event) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      onReset(event);
      inputRef.current.blur();
    }
  };

  return (
    <div
      className={classNames(
        'search-field tw-border-grey-200 focus-within:tw-border-blue-300 hover:focus-within:tw-border-blue-300',
        !isDisabled && 'hover:tw-border-grey-300',
        additionalClasses,
      )}
    >
      {!withoutIcon && (
        <span className='search-field__icon-container'>
          <SearchIcon
            className={classNames(
              'search-field__icon',
              isDisabled ?
                '[&_path]:tw-fill-grey-300'
              : '[&_path]:tw-fill-grey-700',
            )}
            height={24}
            width={24}
          />
        </span>
      )}
      <input
        autoComplete='off'
        autoFocus={autoFocus}
        className={classNames(
          'search-field__input tw-bg-transparent tw-text-grey-900',
          isDisabled ?
            'placeholder:tw-text-grey-300'
          : 'placeholder:tw-text-grey-400',
        )}
        data-attr-name={name}
        disabled={isDisabled}
        name={name}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        ref={inputRef}
        type='text'
        value={value}
      />
      <div className='search-field__clear-container'>
        {value.length > 0 && (
          <div
            className="search-field__clear circle--remove tw-bg-transparent before:tw-bg-grey-700 before:tw-content-[''] after:tw-bg-grey-700 after:tw-content-[''] hover:tw-bg-red-600 hover:before:tw-bg-white hover:after:tw-bg-white"
            data-attr-name={name}
            onClick={onReset}
          />
        )}
      </div>
    </div>
  );
}

SearchField.propTypes = {
  additionalClasses: PropTypes.string,
  autoFocus: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  withoutIcon: PropTypes.bool,
};
